import { connectHook } from 'app/common/components/connect-hook';
import CopyButton from './copy-button';
import { useCopyButton } from './copy-button-hook';

export default connectHook(CopyButton, useCopyButton);
